module.exports = __webpack_public_path__ + "6877508ddbdc59a5177b96711ffa994d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/slideshow_11_mobile.jpg
// module id = 662
// module chunks = 0